import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('cells')
export class Cell {

  @PrimaryGeneratedColumn("increment",{name:'cell_id'})
  cellId:number;
 
  @Column("varchar",{
      nullable:false,
      length:20,
      name:"cell_code"
      })
      cellCode:string;

    @Column("varchar",{
      nullable:false,
      length:30,
      name:"cell_name"
      })
      cellName:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @OneToMany(type=>Cell, cell=>cell.cellId,{cascade: true})
  cellinfo:Cell[];
 
}
